import { useState, useCallback } from 'react';
import { DashboardFilterContext } from './dashboardFilterContextDef';
import { getStoredRange, saveRange } from './dashboardFilterStorage';

export function DashboardFilterProvider({ children }: { children: React.ReactNode }) {
  const [range, setRangeState] = useState(getStoredRange);
  const setRange = useCallback((from: string, to: string) => {
    setRangeState({ from, to });
    saveRange(from, to);
  }, []);
  return (
    <DashboardFilterContext.Provider value={{ range, setRange }}>
      {children}
    </DashboardFilterContext.Provider>
  );
}
